import {
	AGENT_EXECUTIONS_NEWEST_SUCCESS,
	NewestExecutionSuccessAction,
} from '../actions/agent_executions_actions';
import { AOPExecution } from '../types/AOPExecutionTypes';

/**
 * The newest Radar run per work order.
 *
 * Not the standard CRUD generator: that keys records by their own id, and the
 * question being cached here is "what is on work order 123", which is a lookup
 * by something other than the record's key. The shape is small enough that
 * saying so plainly beats bending the generator around it.
 *
 * Three states, not two. A work order missing from `newestByWorkOrder` has not
 * been asked about; one mapped to `null` has been asked about and Radar has
 * never run there. The banner and the tab gate both need that difference —
 * "nothing yet" must not draw the same as "nothing, ever".
 *
 * A failed read writes nothing, so it stays "not asked" and the next mount
 * tries again. That is the behaviour both surfaces already promise: a run they
 * cannot see is one they do not report.
 */
export interface AgentExecutionsStoreState {
	newestByWorkOrder: { [workOrderId: string]: AOPExecution | null };
}

const initialState: AgentExecutionsStoreState = { newestByWorkOrder: {} };

/**
 * Typed to the one action it answers. Every other action falls through the
 * default, so a wider union buys nothing until there is a second one.
 */
export default (
	state: AgentExecutionsStoreState = initialState,
	action: NewestExecutionSuccessAction
): AgentExecutionsStoreState => {
	switch (action.type) {
		case AGENT_EXECUTIONS_NEWEST_SUCCESS:
			return {
				...state,
				newestByWorkOrder: {
					...state.newestByWorkOrder,
					[action.workOrderId]: action.execution,
				},
			};
		default:
			return state;
	}
};
